import controller from './distant-sales-aggreement-dialog.controller';

export default {
  controller,
  template: require('./distant-sales-aggreement-dialog.html')
};



// WEBPACK FOOTER //
// src/app/buy/distant-sales-aggreement-dialog/distant-sales-aggreement-dialog.component.ts